export default function About() {
  return (
    <div className="p-10 text-center">
      <h2 className="text-3xl font-bold text-amber-800 mb-4">About HaaterKaj</h2>
      <p className="max-w-3xl mx-auto text-gray-700">
        About HaaterKaj

HaaterKaj is a celebration of Bengal’s timeless artistry — a living tribute to the craftsmen who have carried forward their heritage through generations. Our platform brings together the finest handmade products from rural West Bengal, connecting skilled artisans directly with customers who appreciate authenticity, culture, and craftsmanship.

Every creation at HaaterKajt tells a story. From handwoven Bengali sarees and intricate Kantha stitches to terracotta sculptures, wooden carvings, jute accessories, and Dokra masterpieces — each product reflects centuries of tradition preserved with love and dedication. These are not just crafts; they are pieces of Bengal’s soul.

We work closely with artisans across rural Bengal, visiting their workshops, understanding their challenges, and ensuring they receive fair value for their work. By eliminating middlemen, we make sure the craftsmen earn what they truly deserve, while customers receive genuine, high-quality handmade products.

When you choose HaaterKaj, you’re supporting more than a brand—you are supporting families, empowering villages, and helping sustain Bengal’s cultural legacy. Your purchase becomes a bridge between ancient craftsmanship and modern homes.

Our vision is simple:
To honor Bengal’s artisans, preserve traditional crafts, and give rural talent a global platform.

Whether you're searching for elegant home décor, traditional Bengali fashion, unique gift items, or handcrafted collectibles, HaaterKaj brings the best of Bengal right to your doorstep — crafted with skill, passion, and heart.

HaaterKaj is not just a marketplace.
It is a movement to keep Bengal’s artistic heritage alive for generations to come.
      </p>
    </div>
  );
}
